import { Link } from "react-router-dom";
import { Linkedin, Instagram, Mail, Phone } from "lucide-react";

const socialLinks = [
  { name: "LinkedIn", icon: Linkedin, href: "https://www.linkedin.com/company/cognigroup" },
  { name: "Instagram", icon: Instagram, href: "https://www.instagram.com/cogni.group/" },
];

export function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground safe-bottom">
      <div className="container-wide py-10 sm:py-12 md:py-16">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
          {/* Contact */}
          <div className="space-y-2 text-sm text-primary-foreground/70">
            <a href="mailto:comercial@cogni.group" className="flex items-center gap-2 hover:text-primary-foreground transition-colors">
              <Mail className="h-4 w-4 flex-shrink-0" />
              <span>comercial@cogni.group</span>
            </a>
            <a href="tel:+5562999961628" className="flex items-center gap-2 hover:text-primary-foreground transition-colors">
              <Phone className="h-4 w-4 flex-shrink-0" />
              <span>(62) 99996-1628</span>
            </a>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-5">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.href}
                className="text-primary-foreground/70 hover:text-primary-foreground transition-colors touch-target flex items-center justify-center"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
              >
                <social.icon className="h-5 w-5" />
              </a>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/10 mt-8 pt-6 text-center">
          <p className="text-primary-foreground/60 text-sm">
            © 2026 Cogni. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
